import { SET_ARRAY_MODEL } from '../constants/ActionTypes';

export const setArrayModel = model => ({
  type: SET_ARRAY_MODEL,
  payload: model,
});
